<script setup lang="ts">
import { useTemplateRef } from 'vue';
import { EmojiPickerTooltip } from '@/components/emoji/index.js';
import UserAvatar from '../user-avatar/UserAvatar.vue';
import type { UserAvatarProps } from '@/components/user-avatar/user-avatar-props.js';
import { useForwardProps } from 'reka-ui';
import type { EmojiData } from 'emoji-mart-vue-fast/src';

type EmojiThrowableUserAvatarProps = UserAvatarProps;

const emit = defineEmits<{
    throw: [emoji: EmojiData, target: DOMRect];
}>();
const avatarRef = useTemplateRef('avatar');
const props = defineProps<EmojiThrowableUserAvatarProps>();
const forwarded = useForwardProps(props);

function getElement(): HTMLElement | null {
    return avatarRef.value?.getElement() ?? null;
}

defineExpose({
    getElement,
});

function handleSelect(emoji: EmojiData) {
    const el = getElement();
    if (!el) return;
    emit('throw', emoji, el.getBoundingClientRect());
}
</script>

<template>
    <EmojiPickerTooltip @select="handleSelect">
        <UserAvatar ref="avatar" v-bind="forwarded" />
    </EmojiPickerTooltip>
</template>
